import { ExplorePageDensityModes } from '@logz-pkg/enums';
import { colorsV2 } from '@logz-ui/styleguide';
import { abortControllerService } from '@logz-pkg/utils';
import { SpecialGraphValues } from './enums';

export const specialFields = [/^message$/, /^@timestamp$/];
export const ignoredFields = [/^_logzio(?!_logceptions)/, /^__logzio/];

export const DEFAULT_TABLE_COLUMNS = [];
export const DEFAULT_COLUMN_SIZE = 150;
export const DEFAULT_SORT = ['-@timestamp'];

export const SOURCE_FIELD_NAME = '_source';
export const EXCEPTIONS_FIELD_NAME = '_logzio_logceptions';
export const INSIGHTS_FIELD_NAME = '_logzio_insights';

export const GROUPBY_FIELD_NAME = '_logzio_group_by_column';
export const ACCOUNTS_FIELD_NAME = '_logzio_accounts_column';

export const customFieldNames = {
  [EXCEPTIONS_FIELD_NAME]: 'exceptions',
};

export const preDefinedGraphColors = {
  [SpecialGraphValues.MISSING]: colorsV2.violet[400],
  [SpecialGraphValues.OTHER]: colorsV2.orange[900],
  error: colorsV2.error[600],
  warn: colorsV2.regularWarning[300],
  info: colorsV2.darkBlue[300],
  success: colorsV2.success[500],
};

export const graphColors = [
  colorsV2.blue[500],
  colorsV2.violet[700],
  colorsV2.pink[600],
  colorsV2.teal[900],
  colorsV2.orange[700],
  colorsV2.green[700],
  colorsV2.pink[800],
  colorsV2.darkBlue[800],
  colorsV2.yellow[700],
  colorsV2.teal[600],
  colorsV2.indigo[900],
];

export const MIN_ALLOWED_COLUMNS = 2;

export const densityModesSizeMap: Record<ExplorePageDensityModes, number> = {
  OneLine: 16,
  TwoLines: 32,
  Expanded: 16,
};

export const REQUEST_MAX_TOKENS = 200000;
export const CHAT_MAX_MESSAGES = 100;
export const CONTEXT_MAX_TOKENS = 25000;
export const CONTEXT_MAX_LOGS = 100;

export const SHORT_QUERY_DEBOUNCE_TIME = 150;
export const LONG_QUERY_DEBOUNCE_TIME = 1500;
export const SURROUNDING_INITIAL_FETCH_AMOUNT = 25;

export const LOGZIO_HIGHLIGHT_TAG = '__logzio-highlight__';
export const DEPLOYMENT_MARKERS_QUERY_KEY = 'explore-deployment-markers';
export const EXPLORE_LUCENE_CALLBACKS_ABORT_KEY = abortControllerService.createUniqueKey('explore-lucene-callbacks');
